import dimmedDisabled from "@mittwald/flow-styles/dist/mixins/dimmedDisabled";
import { focusVisible } from "@mittwald/flow-styles/dist/mixins/focusVisible";
import { color, size } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { Box } from "../../Box";
import { AvatarOverlay } from "./AvatarOverlay";
import { ImageContainer } from "./ImageContainer";
import { InitialsOverlay } from "./InitialsOverlay";
export const Tile = styled(Box) `
  background-color: ${color.base.white};
  border: ${size.border.base.hairline} solid
    ${color.border.selectableBox.default};
  overflow: hidden;

  &:not(.disabled) {
    cursor: pointer;
  }

  &:is(.active) {
    background-color: ${color.background.selectableBox.selected};
  }

  &.disabled > * {
    cursor: default;
    ${dimmedDisabled}
  }

  &:not(.disabled):hover,
  &:not(.disabled).hover {
    background-color: ${color.background.selectableBox.hovered};

    ${AvatarOverlay}, ${InitialsOverlay}, ${ImageContainer} {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  ${focusVisible}
  &.focus, &:focus-visible {
    outline-offset: -1px;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGlsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RpbGUvc3R5bGVkL1RpbGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxjQUFjLE1BQU0sa0RBQWtELENBQUM7QUFDOUUsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLGdEQUFnRCxDQUFDO0FBQzlFLE9BQU8sRUFBRSxLQUFLLEVBQUUsSUFBSSxFQUFFLE1BQU0sZ0RBQWdELENBQUM7QUFDN0UsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFDdkMsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLFdBQVcsQ0FBQztBQUNoQyxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFDaEQsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLGtCQUFrQixDQUFDO0FBQ2xELE9BQU8sRUFBRSxlQUFlLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUVwRCxNQUFNLENBQUMsTUFBTSxJQUFJLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFBO3NCQUNULEtBQUssQ0FBQyxJQUFJLENBQUMsS0FBSztZQUMxQixJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxRQUFRO01BQy9CLEtBQUssQ0FBQyxNQUFNLENBQUMsYUFBYSxDQUFDLE9BQU87Ozs7Ozs7O3dCQVFoQixLQUFLLENBQUMsVUFBVSxDQUFDLGFBQWEsQ0FBQyxRQUFROzs7OztNQUt6RCxjQUFjOzs7Ozt3QkFLSSxLQUFLLENBQUMsVUFBVSxDQUFDLGFBQWEsQ0FBQyxPQUFPOztNQUV4RCxhQUFhLEtBQUssZUFBZSxLQUFLLGNBQWM7Ozs7O0lBS3RELFlBQVk7Ozs7Q0FJZixDQUFDIn0=